import { CommonModule, Location, LocationStrategy, NgIf, PathLocationStrategy } from '@angular/common';
import { Router, NavigationCancel, NavigationEnd, RouterOutlet } from '@angular/router';
import { Component } from '@angular/core';
import { filter } from 'rxjs/operators';
import { FooterComponent } from './components/footer/footer.component';
import { ThemeCustomizerComponent } from './components/theme-customizer/theme-customizer.component';
import { ThemeCustomizerService } from './components/theme-customizer/theme-customizer.service';
import { ThemeService } from './shared/services/theme.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LoadingService } from './loading.service';
import { TranslationService } from './shared/i18n/translation.service';
import { locale as enLang } from './shared/i18n/vocabs/en';
import { locale as arLang } from './shared/i18n/vocabs/ar';
import { locale as trLang } from './shared/i18n/vocabs/tr';
declare let $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent {

    title: any;
    location: any;
    isToggled = false;
    routerSubscription: any;

    constructor(
        private router: Router,
        public themeService: ThemeCustomizerService,
        public modernThemeService: ThemeService,
        public loadingService: LoadingService,
        private translationService: TranslationService,


    ) {
        this.translationService.loadTranslations(
            arLang,
            trLang,
            enLang,
          );
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit() {
        // Clear any stored dark theme so site always opens light
        if (localStorage.getItem('theme') === 'dark') {
            localStorage.removeItem('theme');
            this.modernThemeService.setTheme('light');
        }
        this.recallJsFuntions();
        this.setInitialDirection();
    }

    setInitialDirection() {
        // Set initial direction based on current language
        const currentLang = this.translationService.getSelectedLanguage();
        if (currentLang === 'ar') {
            document.documentElement.setAttribute('dir', 'rtl');
        } else {
            document.documentElement.setAttribute('dir', 'ltr');
        }
    }

    recallJsFuntions() {
        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
            .subscribe(event => {
                this.location = this.router.url;
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                window.scrollTo(0, 0);
            });
    }

}